import { render, staticRenderFns } from "./tabLessThanCarloadBaseUICustomLayout.vue?vue&type=template&id=2c7c8cbe&"
import script from "./tabLessThanCarloadBaseUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabLessThanCarloadBaseUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7c8cbe')) {
      api.createRecord('2c7c8cbe', component.options)
    } else {
      api.reload('2c7c8cbe', component.options)
    }
    module.hot.accept("./tabLessThanCarloadBaseUICustomLayout.vue?vue&type=template&id=2c7c8cbe&", function () {
      api.rerender('2c7c8cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBaseUICustomLayout.vue"
export default component.exports